<template>
  <div>
   <nav class="main-header navbar navbar-expand navbar-arendal">
    <!-- Left navbar links -->
    <li class="nav-item burger-only-mobile" style="margin-left: -20px;font-size: 1.2em;">
        <span class="burger-item" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></span>
    </li>
    <ul class="navbar-nav">
      
      <!-- AGREGAR UN MENU SIN ARBOL
			<li class="nav-item d-none d-sm-inline-block">      
          <router-link class="nav-link" to="/home">Home</router-link>
      </li>
    -->
		<!--Menu ORDEN COMPRAS-->
    <li v-if="modalONOFF" class="nav-item" style="cursor: default;font-size: 1.2em; cursor:pointer;" @click="resetModal()" v-b-modal.modal-proveedores>
      {{proveedorNom}} <span style="display:none;">User is inactive = {{isInactive}}</span>
    </li>
    <li v-else class="nav-item" style="cursor: default;font-size: 1.2em;">
      {{proveedorNom}}
    </li>
		<!--<li class="nav-item d-none d-sm-inline-block dropdown">
			<a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="true">Facturas<span class="caret"></span></a>
			<ul class="dropdown-menu" role="menu">
				<li class="">
					<router-link class="nav-link" to="/EnvioFacturas">Enviar facturas</router-link>
				</li>
			</ul>
		</li>-->
		<!--Menu ORDEN COMPRAS-->
		<!--<li class="nav-item d-none d-sm-inline-block dropdown">
			<a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="true">OC<span class="caret"></span></a>
			<ul class="dropdown-menu" role="menu">
				<li class="">
					<router-link class="nav-link" to="/OCDocPendiente">Doc. pendiente</router-link>
				</li>
			</ul>
		</li>-->
		<!---->
    </ul>

    <!-- SEARCH FORM -->
    <!--<form class="form-inline ml-3">
      <div class="input-group input-group-sm">
        <input class="form-control form-control-navbar" type="search" placeholder="Search" aria-label="Search">
        <div class="input-group-append">
          <button class="btn btn-navbar" type="submit">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </form>-->

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item d-flex align-items-center" style="margin-right:8px;">
        <LangSwitcher :navbar-mode="true" />
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" style="color:#FFFFFF;" href="#">
          <i class="far fa-user"></i>
          {{nombreUS}} {{apellidoUS}}
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">   
          <p class="dropdown-item" @click="logout">
          <i class="far fa-sign-out"></i>{{LangSelected.Interno.CerrarSesion}}
          </p>
        </div>
      </li>
      <!-- Messages Dropdown Menu -->
      <!--<li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-comments"></i>
          <span class="badge badge-danger navbar-badge">3</span>
        </a>-->
        <!--<div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a href="#" class="dropdown-item">
            <div class="media">
              <img src="dist/img/user1-128x128.jpg" alt="User Avatar" class="img-size-50 mr-3 img-circle">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  Brad Diesel
                  <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">Call me whenever you can...</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <div class="media">
              <img src="dist/img/user8-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  John Pierce
                  <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">I got your message bro</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <div class="media">
              <img src="dist/img/user3-128x128.jpg" alt="User Avatar" class="img-size-50 img-circle mr-3">
              <div class="media-body">
                <h3 class="dropdown-item-title">
                  Nora Silvester
                  <span class="float-right text-sm text-warning"><i class="fas fa-star"></i></span>
                </h3>
                <p class="text-sm">The subject goes here</p>
                <p class="text-sm text-muted"><i class="far fa-clock mr-1"></i> 4 Hours Ago</p>
              </div>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Messages</a>
        </div>
      </li>-->
      <!-- Notifications Dropdown Menu -->
      <!--<li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-warning navbar-badge">15</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 4 new messages
            <span class="float-right text-muted text-sm">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-users mr-2"></i> 8 friend requests
            <span class="float-right text-muted text-sm">12 hours</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 new reports
            <span class="float-right text-muted text-sm">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
        </div>
      </li>-->
      <!--<li class="nav-item">
        <a class="nav-link" data-widget="control-sidebar" data-slide="true" href="#" role="button"><i
            class="fas fa-th-large"></i></a>
      </li>-->
    </ul>
  </nav>
  <b-modal id="modal-proveedores" ref="modal-proveedores" title="Cambiar proveedor" size="400px" button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
								<span class="col-sm-12 span-label" style="padding-top: 0px;">Proveedor:</span>
								<div class="col-sm-12" style="text-align:center;">
                  <!--<DxSelectBox
                    :search-enabled="true"
                    :data-source="ProveedoresSelector"
                    :search-mode="searchModeOption"
                    :search-expr="searchExprOption"
                    :search-timeout="searchTimeoutOption"
                    :min-search-length="minSearchLengthOption"
                    :show-data-before-search="showDataBeforeSearchOption"
                    placeholder="5 caracteres minimo para la busqueda"
                    display-expr="Proveedor"
                    value-expr="Id_Proveedor"
                    v-model="Id_ProveedorSelector"
                    @value-changed="onChange()"
                  />-->
                  <DxAutocomplete
                    :data-source="ProveedoresSelector"
                    v-model="ProveedorSelector"
                    :min-search-length="5"
                    :search-timeout="500"                            
                    :searchExpr="searchExprOption"
                    :searchMode="searchModeOption"
                    displayExpr="Id_Proveedor"
                    valueExpr="Proveedor"
                    placeholder="Escribe 5 caracters para buscar..."
                    @value-changed="onChange()"
                  />
                  <div id="LoadPageProveedores" v-show="ProveedoresSelector.length<=0" style="position: absolute;width: 93%;background: #000000a8;color: #fff;top: 0px;height: 24px;border-radius: 5px;">
                    <p>Cargando proveedores</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
        <b-button size="sm" variant="secondary" @click="ChangeProveedor(0)"><!--RefreshFirstList()-->
          Cancelar
        </b-button>
        <b-button size="sm" variant="primary" @click="ChangeProveedor(1)"><!--RefreshFirstList()-->
          Cambiar 
        </b-button>
      </template>
  </b-modal>
  <b-modal id="modal-changeProveedor" ref="modal-changeProveedor" header-bg-variant="danger" title="Información" size="400px" button-size="sm" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 15px;">
								<span class="col-sm-12 span-label" style="padding-top: 0px;padding: 0px;font-weight: normal;">No se puede cambiar al proveedor <b>"{{ProveedorSeleccionado}}"</b> ya que no se le ha enviado la invitación a dicho proveedor para unirse al portal de Proveedores de Arendal.</span>
              </div>	
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-12 span-label" style="padding-top: 0px;padding: 0px;font-weight: normal;">ACCIÓN: Invitar al proveedor en la parte izquierda de la pantalla o en el boton inferior.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="">
      <b-button size="sm" variant="secondary" @click="ChangeProveedor(0)"><!--RefreshFirstList()-->
        Cancelar
      </b-button>
      <b-button size="sm" variant="primary" @click="ChangeProveedor(2)"><!--RefreshFirstList()-->
        Invitar al proveedor 
      </b-button>
    </template>
  </b-modal>
  </div>
</template>

<script>
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;
//import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxAutocomplete } from 'devextreme-vue/autocomplete';
import apiClient from '@/services/apiClient';
import LangSwitcher from '@/components/LangSwitcher.vue';


/*let userActivityTimeout = null;

function resetUserActivityTimeout() {
  console.log('214: resetUserActivityTimeout');
  clearTimeout(userActivityTimeout);
  userActivityTimeout = setTimeout(() => {
    inactiveUserAction();
  }, INACTIVE_USER_TIME_THRESHOLD);
}

function inactiveUserAction() {
  console.log('222: inactiveUserAction');
  // logout logic
}

function activateActivityTracker() {
  window.addEventListener("mousemove", resetUserActivityTimeout);
  window.addEventListener("scroll", resetUserActivityTimeout);
  window.addEventListener("keydown", resetUserActivityTimeout);
  window.addEventListener("resize", resetUserActivityTimeout);
}

let userActivityThrottlerTimeout = null;

function userActivityThrottler() {
  if (!userActivityThrottlerTimeout) {
    userActivityThrottlerTimeout = setTimeout(() => {
      resetUserActivityTimeout();

      clearTimeout(userActivityThrottlerTimeout);
      userActivityThrottlerTimeout = null;
    }, USER_ACTIVITY_THROTTLER_TIME);
  }
}

function activateActivityTracker() {
  window.addEventListener("mousemove", userActivityThrottler);
  // ...
}*/

export default {
    components: {
      DxAutocomplete,
      LangSwitcher
    },
    data() {
      return{
        LangSelected:JSON.parse(localStorage.getItem('languageInfo')),
        nombreUS: localStorage.getItem('NomUs'),
        apellidoUS: localStorage.getItem('ApeUs'),
        proveedorNom: localStorage.getItem('NomP'),
        idProve: localStorage.getItem('IDUS'),
        SesionID: localStorage.getItem('SesionID'),
        modalONOFF:localStorage.getItem('mail').toLowerCase().includes("arendal.com.mx"),
        ProveedoresSelector:[],
        searchModeOption: 'contains',
        searchExprOption: 'Proveedor',
        searchTimeoutOption:200,
        minSearchLengthOption: 5,
        showDataBeforeSearchOption: false,
        Id_ProveedorSelector:null,
        ProveedorSelector:localStorage.getItem('NomP'),
        
        ProveedorSeleccionado:'',
        isInactive: false,
        userActivityThrottlerTimeout: null,
        userActivityTimeout: null
      }
    },
    name: 'MenuEncabezado',    
    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn},
      SUBc() {
        return localStorage.getItem('SUBc');
      }
    },
    beforeMount() {
      clearTimeout(this.userActivityTimeout);
      clearTimeout(this.userActivityThrottlerTimeout);
      this.activateActivityTracker();
      this.userActivityThrottler();
    },
    created: function(){
      var that = this;
      // El selector de proveedores es solo para usuarios internos de Arendal.
      // La API restringe getProveedores a rol Interno (H-03); evitamos el 403
      // no llamandolo para proveedores externos.
      if (localStorage.getItem('AREu') == 1) {
        apiClient.get('/api/Materiales/getProveedores', {
          params: { Param1: -1, Param2: 0, Param3: 0, Param4: -1, FormatoXML: false }
        })
        .then(function (response) {
          that.ProveedoresSelector = response.data;
          that.Id_ProveedorSelector = that.idProve;
        })
        .catch(function (error) {
          console.log('Error: ' + error);
        });
      }
    },
    methods: {
      logout: function () {
        console.log(this.SesionID);
        this.$store.dispatch('logout',{SesionID:this.SesionID});       
        this.$router.push('/login')        
      },
      onChange:function() {
        var comparation = this.ProveedorSelector;
        var result = this.ProveedoresSelector.filter(function (data) { return data.Proveedor == comparation; });   
        //console.log(result); 
        if(result[0]){
          this.Id_ProveedorSelector = result[0].Id_Proveedor;
        }
      },
      ChangeProveedor:function(value){
        var that = this;
        if(value==1){
          //console.log(this.Id_ProveedorSelector);
          //console.log(this.ProveedoresSelector);
          var dataProveedorSelected;
          dataProveedorSelected = (function(){
            var result = [];
            for (var i=0, l=that.ProveedoresSelector.length; i<l; i++)
              if (that.ProveedoresSelector[i].Id_Proveedor == that.Id_ProveedorSelector){
                result.push(that.ProveedoresSelector[i]);
              }
            return result;
          }());
          if(dataProveedorSelected[0].PermiteEnviosInternos==1 || dataProveedorSelected[0].PermitirEnviosInternos==1){
            console.log(dataProveedorSelected);
            var subcon = (this.modalONOFF)?1:dataProveedorSelected[0].Subcontratista;
            that.proveedorNom = dataProveedorSelected[0].Proveedor;
            that.Id_ProveedorSelector = dataProveedorSelected[0].Id_Proveedor;
            localStorage.setItem('IDUS', this.Id_ProveedorSelector);
            localStorage.setItem('NomP', dataProveedorSelected[0].Proveedor);
            localStorage.setItem('RFCP', dataProveedorSelected[0].RFC);
            localStorage.setItem('PAISP', dataProveedorSelected[0].Pais || '');
            localStorage.setItem('PRem', dataProveedorSelected[0].PermitirNotasRemision);
            localStorage.setItem('PEI', dataProveedorSelected[0].PermitirEnviosInternos);
            localStorage.setItem('SUBc', subcon);
            console.log(localStorage.getItem('SUBc'));
            // H-03: re-emitir el JWT para asumir el proveedor. La API confia en el
            // rol firmado en el token (Interno), no en el IDUS de localStorage.
            apiClient.post('/api/auth/assume-provider', { Id_Proveedor: parseInt(that.Id_ProveedorSelector) })
              .then(function (resp) {
                localStorage.setItem('jwt', resp.data.JWT);
                that.$refs['modal-proveedores'].hide();
                //that.$router.push({name:'Home'});
                window.location.reload(true);
              })
              .catch(function (error) {
                console.log('Error al asumir proveedor: ' + error);
              });
            //that.$router.push({name:'OCDocumentacionPendiente'});
          }else{
            that.ProveedorSeleccionado = dataProveedorSelected[0].Proveedor;
            that.$refs['modal-changeProveedor'].show();
          }
        }else if(value==2){
          that.$refs['modal-proveedores'].hide();
          that.$refs['modal-changeProveedor'].hide();
          this.$router.push('/InvitacionProveedores');
        }else{
          that.$refs['modal-proveedores'].hide();
          that.$refs['modal-changeProveedor'].hide();
        }
      },
      resetModal:function() {
        var that = this;
        that.Id_ProveedorSelector = localStorage.getItem('IDUS');
        that.ProveedorSelector = localStorage.getItem('NomP');
      },


      activateActivityTracker() {
        window.addEventListener("mousemove", this.userActivityThrottler);
        window.addEventListener("scroll", this.userActivityThrottler);
        window.addEventListener("keydown", this.userActivityThrottler);
        window.addEventListener("resize", this.userActivityThrottler);
      },
      resetUserActivityTimeout() {
      console.log('Reseteando tiempo para expirar la sesion 15min restantes');
        clearTimeout(this.userActivityTimeout);
        this.userActivityTimeout = setTimeout(() => {
          console.log('Sesion expirada')
          this.inactiveUserAction();
          this.isInactive=true;
          console.log('resetUserActivityTimeout');
        }, 900000);//180000, 900000
      },
      userActivityThrottler() {
        if (!this.userActivityThrottlerTimeout) {
          //console.log('373:userActivityThrottler');
          console.log(this.userActivityThrottlerTimeout);
          this.userActivityThrottlerTimeout = setTimeout(() => {
            this.resetUserActivityTimeout();
            this.isInactive=false;
            clearTimeout(this.userActivityThrottlerTimeout);
            this.userActivityThrottlerTimeout = null;
          }, 5000);
        }
      },
      inactiveUserAction(){
        window.removeEventListener("mousemove", this.userActivityThrottler);
        window.removeEventListener("scroll", this.userActivityThrottler);
        window.removeEventListener("keydown", this.userActivityThrottler);
        window.removeEventListener("resize", this.userActivityThrottler);
      
        clearTimeout(this.userActivityTimeout);
        clearTimeout(this.userActivityThrottlerTimeout);
        this.logout();
      }
    }
}
</script>